const Sidebar = () => {
  const toggle = document.querySelector(".js-toggle-sidebar");

  if (toggle) {
    toggle.addEventListener("click", () => {
      document.body.classList.toggle("show-sidebar");
      const show = document.body.classList.contains("show-sidebar");

      // toggle aria-expanded
      toggle.setAttribute("aria-expanded", show);

      // if body has class show-sidebar then add tabindex to the sidebar-menu
      if (show) {
        document.querySelector("#sidebar-menu").setAttribute("tabindex", "0");
      } else {
        document.querySelector("#sidebar-menu").setAttribute("tabindex", "-1");
      }
    });

    // if esc key pressed then close sidebar
    document.addEventListener("keydown", (e) => {
      if (e.keyCode === 27) {
        document.body.classList.remove("show-sidebar");
        toggle.setAttribute("aria-expanded", false);
        document.querySelector("#sidebar-menu").setAttribute("tabindex", "-1");
      }
    });
  }
};

export default Sidebar;
